import get from 'lodash/get';
import set from 'lodash/set';
import unset from 'lodash/unset';
import assign from 'lodash/assign';
import clone from 'lodash/clone';

let validationsServiceState;

const initValidationsServiceState = () => {
    validationsServiceState = {};
};

const getCompValidationState = (compId) => clone(get(validationsServiceState, compId));

const setCompValidationState = (compId, validationState) => {
    const currentValidationState = getCompValidationState(compId);

    const newValidationState = assign({}, currentValidationState, validationState);

    set(validationsServiceState, [compId], newValidationState);
};

const unsetCompValidationState = (compId) => {
    unset(validationsServiceState, compId);
};

export {
    initValidationsServiceState,
    getCompValidationState,
    setCompValidationState,
    unsetCompValidationState
};



// WEBPACK FOOTER //
// ./js/modules/privates/validationsService/validationsServiceState.es6